import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { transformCivilStatus } from 'shell/utils/consult-person/response-transformer/marital-status/civil-status';
import { RegistrationCivilUnionFormVM } from 'mutation/view-models/registration-civil-union';
import { CivilStatusID } from 'shell/constants/civil-status';
import { DateTime } from 'luxon';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';
import { ActType } from 'shell/constants/act-type';

export const checkPersonRegistrationCivilUnion = (civilStatus: string | undefined): boolean => {
  if (civilStatus === CivilStatusID.coniugato || civilStatus === CivilStatusID.unitoCivilmente) {
    return false;
  }

  return true;
};

export const transformerRegistrationCivilUnionData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): RegistrationCivilUnionFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person);

  const familyCoexistence = transformFamilyCoexistence(person);

  const citizenship = transformCitizenship(person);

  const civilStatus = transformCivilStatus(person);

  return {
    person: personData,
    citizenship,
    familyCoexistence,
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    civilStatus: {
      ...(civilStatus || {}),
      oldStatus: civilStatus?.status,
      status: CivilStatusID.unitoCivilmente,
    },
    civilUnion: {
      searchPerson: {
        fiscalCode: '',
      },
      person: {
        surname: '',
        name: '',
        withoutName: false,
        withoutSurname: false,
      },
      isForeign: false,
      italian: {
        municipality: null,
      },
      foreign: {
        foreignState: null,
      },
      dateEvent: null,
      exceptionalPlace: undefined,
      paper: emptyPaper,
      digital: emptyDigital,
      actType: ActType.AttoCartaceo,
    },
  };
};
